import type { GetMyOptionsDtoResVoiceLang } from "../api/generated"
import type { SelectVoiceItemType } from "../types"

export const VOICES: Record<
  GetMyOptionsDtoResVoiceLang,
  SelectVoiceItemType[]
> = {
  ENGLISH: [
    {
      id: "af_alloy",
      name: "Alloy",
      gradient: ["#60A5FA", "#A855F7", "#EC4899"],
      description: "Our best voice—great for any purpose",
    },
    {
      id: "af_aoede",
      name: "Aoede",
      gradient: ["#86EFAC", "#3B82F6", "#9333EA"],
      description: "Melodic American, ideal for audiobooks",
    },
    {
      id: "af_bella",
      name: "Bella",
      gradient: ["#FACC15", "#EF4444", "#EC4899"],
      description: "Youthful American, great for educational content",
    },
    {
      id: "af_kore",
      name: "Kore",
      gradient: ["#A5B4FC", "#A855F7", "#F87171"],
      description: "Energetic American, perfect for commercials",
    },
    {
      id: "af_nicole",
      name: "Nicole",
      gradient: ["#4ADE80", "#06B6D4", "#3B82F6"],
      description: "Professional American, suited for business presentations",
    },
    {
      id: "af_nova",
      name: "Nova",
      gradient: ["#FB923C", "#EC4899", "#A855F7"],
      description: "Dynamic American, ideal for podcasts",
    },
    {
      id: "af_sarah",
      name: "Sarah",
      gradient: ["#2DD4BF", "#3B82F6", "#6366F1"],
      description: "Friendly American, great for customer service",
    },
    {
      id: "am_echo",
      name: "Echo",
      gradient: ["#F87171", "#EC4899", "#A855F7"],
      description: "Clear American, perfect for announcements",
    },
    {
      id: "am_eric",
      name: "Eric",
      gradient: ["#60A5FA", "#A855F7", "#EC4899"],
      description: "Confident American, suited for motivational content",
    },
    {
      id: "am_fenrir",
      name: "Fenrir",
      gradient: ["#86EFAC", "#3B82F6", "#9333EA"],
      description: "Deep American, ideal for dramatic narratives",
    },
    {
      id: "am_michael",
      name: "Michael",
      gradient: ["#FACC15", "#EF4444", "#EC4899"],
      description: "Authoritative American, great for documentaries",
    },
    {
      id: "am_onyx",
      name: "Onyx",
      gradient: ["#A5B4FC", "#A855F7", "#F87171"],
      description: "Smooth American, perfect for luxury brand content",
    },
    {
      id: "am_puck",
      name: "Puck",
      gradient: ["#4ADE80", "#06B6D4", "#3B82F6"],
      description: "Playful American, ideal for children's content",
    },
    {
      id: "bf_alice",
      name: "Alice",
      gradient: ["#FB923C", "#EC4899", "#A855F7"],
      description: "Sophisticated British, excellent for audiobooks",
    },
    {
      id: "bf_emma",
      name: "Emma",
      gradient: ["#2DD4BF", "#3B82F6", "#6366F1"],
      description: "Warm British, perfect for lifestyle content",
    },
    {
      id: "bf_isabella",
      name: "Isabella",
      gradient: ["#F87171", "#EC4899", "#A855F7"],
      description: "Elegant British, suited for luxury brand narratives",
    },
    {
      id: "bm_fable",
      name: "Fable",
      gradient: ["#60A5FA", "#A855F7", "#EC4899"],
      description: "Enchanting British, ideal for storytelling",
    },
    {
      id: "bm_george",
      name: "George",
      gradient: ["#86EFAC", "#3B82F6", "#9333EA"],
      description: "Authoritative British, great for news broadcasts",
    },
    {
      id: "bm_lewis",
      name: "Lewis",
      gradient: ["#FACC15", "#EF4444", "#EC4899"],
      description: "Friendly British, perfect for travel content",
    },
  ],
  SPANISH: [
    {
      id: "ef_dora",
      name: "Dora",
      gradient: ["#60A5FA", "#A855F7", "#EC4899"],
    },
    {
      id: "em_alex",
      name: "Alex",
      gradient: ["#86EFAC", "#3B82F6", "#9333EA"],
    },
    {
      id: "em_santa",
      name: "Santa",
      gradient: ["#FACC15", "#EF4444", "#EC4899"],
    },
  ],
  FRENCH: [
    {
      id: "ff_siwis",
      name: "Siwis",
      gradient: ["#60A5FA", "#A855F7", "#EC4899"],
    },
  ],
  ITALIAN: [
    {
      id: "if_sara",
      name: "Sara",
      gradient: ["#60A5FA", "#A855F7", "#EC4899"],
    },
    {
      id: "im_nicola",
      name: "Nicola",
      gradient: ["#86EFAC", "#3B82F6", "#9333EA"],
    },
  ],
  PORTUGUESE: [
    {
      id: "pf_dora",
      name: "Dora",
      gradient: ["#60A5FA", "#A855F7", "#EC4899"],
    },
    {
      id: "pm_alex",
      name: "Alex",
      gradient: ["#86EFAC", "#3B82F6", "#9333EA"],
    },
    {
      id: "pm_santa",
      name: "Santa",
      gradient: ["#FACC15", "#EF4444", "#EC4899"],
    },
  ],
}
